import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'components.ProfileEditPopup.SectionSecurity.EmailChangeViaSupportRequestedPopup',
    {
        title: 'We received a request to{br}change your email address',
        description: 'Once this has been processed, we will inform you{br}accordingly. Thank you for your patience.',
        buttonDone: 'Done',
    }
);
